import { defineMessages } from 'react-intl';

export const eventOperationErrorMessages = defineMessages({
    couldNotOpenConnectionToBanknoteValidator: {
        id: 'could-not-open-connection-to-banknote-validator',
        defaultMessage: 'Could not open connection to banknote validator',
    },
    couldNotOpenConnectionToCoinSelector: {
        id: 'could-not-open-connection-to-coin-selector',
        defaultMessage: 'Could not open connection to coin selector',
    },
    couldNotOpenConnectionToPayout: {
        id: 'could-not-open-connection-to-payout',
        defaultMessage: 'Could not open connection to payout',
    },
    couldNotOpenConnectionToDongle: {
        id: 'could-not-open-connection-to-dongle',
        defaultMessage: 'Could not open connection to dongle',
    },
    lostConnectionToBanknoteValidator: {
        id: 'lost-connection-to-banknote-validator',
        defaultMessage: 'Lost connection to banknote validator',
    },
    lostConnectionToCoinSelector: {
        id: 'lost-connection-to-coin-selector',
        defaultMessage: 'Lost connection to coin selector',
    },
    lostConnectionToDongle: {
        id: 'lost-connection-to-dongle',
        defaultMessage: 'Lost connection to dongle',
    },
    lostConnectionToPayout: {
        id: 'lost-connection-to-payout',
        defaultMessage: 'Lost connection to payout',
    },
    unknownError: {
        id: 'unknown-error',
        defaultMessage: 'Unknown error',
    },
    banknoteJamError: {
        id: 'banknote-jam-error',
        defaultMessage: 'Banknote jam detected',
    },
    banknoteValidatorFraudAttemptError: {
        id: 'banknote-validator-fraud-attempt-error',
        defaultMessage: 'Banknote validator fraud attempt detected',
    },
    banknoteValidatorMaintenanceError: {
        id: 'banknote-validator-maintenance-error',
        defaultMessage: 'Banknote validator requires maintenance',
    },
    failedBanknoteValidationError: {
        id: 'failed-banknote-validation-error',
        defaultMessage: 'Failed banknote validation',
    },
    banknoteValidatorCalibrationError: {
        id: 'banknote-validator-calibration-error',
        defaultMessage: 'Banknote validator calibration error',
    },
    busy: {
        id: 'busy',
        defaultMessage: 'Busy',
    },
    cashboxRemoved: {
        id: 'cashbox-removed',
        defaultMessage: 'Cashbox removed',
    },
    coinJamError: {
        id: 'coin-jam-error',
        defaultMessage: 'Coin jam detected',
    },
    coinSelectorFraudAttemptError: {
        id: 'coin-selector-fraud-attempt-error',
        defaultMessage: 'Coin selector fraud attempt detected',
    },
    coinStringError: {
        id: 'coin-string-error',
        defaultMessage: 'Coin string error',
    },
    coinRejectError: {
        id: 'coin-reject-error',
        defaultMessage: 'Coin rejected',
    },
    coinSelectorMaintenanceError: {
        id: 'coin-selector-maintenance-error',
        defaultMessage: 'Coin selector requires maintenance',
    },
    coinInhibitError: {
        id: 'coin-inhibit-error',
        defaultMessage: 'Coin inhibit error',
    },
    coinSelectorCalibrationError: {
        id: 'coin-selector-calibration-error',
        defaultMessage: 'Coin selector calibration error',
    },
    none: {
        id: 'none',
        defaultMessage: 'No error',
    },
    cashboxReplaced: {
        id: 'cashbox-replaced',
        defaultMessage: 'Cashbox replaced',
    },
    successfulConnectionToBanknoteValidator: {
        id: 'successful-connection-to-banknote-validator',
        defaultMessage: 'Successfully connected to banknote validator',
    },
    successfulConnectionToCoinSelector: {
        id: 'successful-connection-to-coin-selector',
        defaultMessage: 'Successfully connected to coin selector',
    },
});
